import { render, staticRenderFns } from "./KasaA4Pregled.vue?vue&type=template&id=2fbd653e&scoped=true"
import script from "./KasaA4Pregled.vue?vue&type=script&lang=js"
export * from "./KasaA4Pregled.vue?vue&type=script&lang=js"
import style0 from "./KasaA4Pregled.vue?vue&type=style&index=0&id=2fbd653e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd653e",
  null
  
)

export default component.exports